import React, { useCallback, useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export const TrafficSummary = () => {
  const { api } = useAuth();
  const [hours, setHours] = useState(24);
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true); setError(false); setData(null);
    try { setData((await api('get', `/api/admin/traffic/summary?hours=${hours}`)).data); }
    catch { setError(true); }
    finally { setLoading(false); }
  }, [api, hours]);
  useEffect(() => { load(); }, [load]);
  const metrics = [
    ['unique_browser_ids', 'Unieke browser-ID’s'], ['pageviews', 'Paginaweergaven'],
    ['scans_started', 'Gestarte scans'], ['scans_completed', 'Afgeronde scans'],
  ];
  return (
    <section data-testid="traffic-period-summary" className="mb-6 pb-6 border-b border-white/10">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <h2 data-testid="traffic-period-title" className="text-base md:text-lg text-white font-semibold">Bezoek & scans</h2>
        <div className="flex gap-2">
          {[24, 48].map(value => <button key={value} data-testid={`traffic-summary-hours-${value}`} aria-pressed={hours === value} disabled={loading} onClick={() => setHours(value)} className={`px-3 py-2 rounded-md text-xs font-semibold ${hours === value ? 'bg-[#D4A017] text-[#0f172a]' : 'bg-white/10 text-white'}`}>{value} uur</button>)}
          <button data-testid="traffic-summary-refresh" aria-label="Bezoek en scans vernieuwen" title="Vernieuwen" disabled={loading} onClick={load} className="px-3 py-2 rounded-md bg-white/10 text-white"><RefreshCw size={15} className={loading ? 'animate-spin' : ''} /></button>
        </div>
      </div>
      {error ? <p role="alert" data-testid="traffic-summary-error" className="text-amber-300 text-sm">Cijfers niet beschikbaar. Probeer opnieuw; er worden geen vervangende cijfers getoond.</p> :
        <div className="grid grid-cols-2 xl:grid-cols-4 gap-x-6 gap-y-5">
          {metrics.map(([key, label]) => <div key={key}>
            <p data-testid={`traffic-summary-${key}-label`} className="text-xs text-gray-400 mb-2">{label}</p>
            <p data-testid={`traffic-summary-${key}`} className="text-2xl text-white font-semibold">{loading ? '…' : new Intl.NumberFormat('nl-NL').format(data?.[key] ?? 0)}</p>
          </div>)}
        </div>}
      {data && <p data-testid="traffic-summary-window" className="text-xs text-gray-400 mt-4">{new Date(data.since).toLocaleString('nl-NL')} – {new Date(data.until).toLocaleString('nl-NL')} · Bezoekers op basis van browser-ID’s, scans uit het scanlogboek.</p>}
    </section>
  );
};